/**
 * Blupay's live payout coverage.
 *
 * Zuba's corridor map may support more countries and channels than we've
 * actually turned on for Blupay. This file is the single place that says
 * what we currently expose to recipients — everything else (country
 * picker, channel picker, "which countries fetch banks") derives from it.
 *
 * To add a new market or channel, edit this object only.
 */
export const PAYOUT_COVERAGE = {
  KE: ["mobile_money", "bank_transfer"],
  GH: ["mobile_money", "bank_transfer"],
  CM: ["mobile_money", "bank_transfer"],
};

export const SUPPORTED_PAYOUT_COUNTRY_CODES =
  Object.keys(PAYOUT_COVERAGE);

/**
 * Whether Blupay currently supports this channel for this country.
 * Safe to call with undefined/lowercase input.
 */
export function isChannelSupported(countryCode, channelKey) {
  const channels =
    PAYOUT_COVERAGE[
      String(countryCode || "").toUpperCase()
    ];

  return (
    Array.isArray(channels) &&
    channels.includes(channelKey)
  );
}